
import { CPProductName, getCPProductFromHostname } from "./CPProducts.js";
import { GA4InitConfig } from "./GA4InitConfig.js";

export const ga4Accounts = {
    FANPAGE: "G-QE4WQDQJ7S",
    OHGA: " G-DZ1YRJEWCC",
    COOKIST_COM: "G-TMYJKFQ0NL",
    COOKIST_IT: "G-WE9QZ4Q5TB",
    KODAMI_IT: "G-QHESD2FQPM",
    GEOPOP_IT: "G-F8BJ7ERJS6",
    WAMILY_IT: "G-8RY0DPF63T",
    LEXPLAIN_IT: "G-1YLDXFKFQJ"
}

let domainMap: Record<CPProductName,GA4InitConfig> = {
    "FANPAGE": {
        accountId: ga4Accounts.FANPAGE,
        cookieDomain: "auto"
    },
    "OHGA": {
        accountId: ga4Accounts.OHGA,
        cookieDomain: "auto"
    },
    "COOKIST_WOW": {
        accountId: ga4Accounts.COOKIST_COM,
        cookieDomain: "auto"
    },
    "COOKIST": {
        accountId: ga4Accounts.COOKIST_IT,
        cookieDomain: "auto"
    },
    "KODAMI": {
        accountId: ga4Accounts.KODAMI_IT,
        cookieDomain: "auto"
    },
    "GEOPOP": {
        accountId: ga4Accounts.GEOPOP_IT,
        cookieDomain: "auto"
    },
    "WAMILY": {
        accountId: ga4Accounts.WAMILY_IT,
        cookieDomain: "auto"
    },
    "LEXPLAIN": {
        accountId: ga4Accounts.LEXPLAIN_IT,
        cookieDomain: "auto"
    }
};

export function getDomainGA4Analytics(secondLevel: string): GA4InitConfig {
    let usemap = null;
    const context = getCPProductFromHostname(secondLevel);
    if(context in domainMap) {
        usemap = domainMap[context];
    }
    else usemap = domainMap.FANPAGE;
    usemap.cookieDomain = "." + secondLevel;
    return usemap;
}
